import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/real-estate-listing.css";
// @ts-ignore
import ValuationBanner from "./vue/ValuationBanner.vue";
import axios from "axios";
// @ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
import "core-js/modules/es.array.iterator";
import * as Listing from "./components/listing";
import { LISTING_MODE } from "./components/listing";
//@ts-ignore
import { decodeCookie, encodeCookie, removeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { parsePoints, calcPolygonCenter } from "@utils/MapUtils";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
//@ts-ignore
import PlaceBox from "@vueEntry/PlaceBox.vue";
//@ts-ignore
import { updateRealEstateSearch, updateViewListing } from "@services/statisticsAPI";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
//@ts-ignore
import { useFavourite } from "@wkComposables/useFavourite";
import commonAsyncComponents from "./vue/CommonComponents/CommonModals";
import { Modals } from "./Types/Modals";
//@ts-ignore
import { useSaveSearchModal } from "@wkComposables/useSaveSearchModal";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import { COLORS, MAP_TILER_APIKEY } from "@wkWebSrc/js/components/variables";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
// @ts-ignore
import { getMapMarkers, getRealEstatesData } from "@services/realEstateAPI";
// @ts-ignore
import BaseTooltip from "@vueEntry/UIKitComponents/BaseTooltip.vue";
// @ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { createApp, defineAsyncComponent, ref } from "vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
//@ts-ignore
import BlogBanner from "@vueEntry/BlogBanner.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
//@ts-ignore
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
import { mapActions, mapState, createPinia } from "pinia";
import { useBaseStore, useSearchBeanStore, useModalStore, usePublicUserMenuStore, useLoggedUserStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import { IMAGE_FORMATS } from "@customTypes/ImageFormatsEnum";
//@ts-ignore
import { transformReImages } from "@utils/ImageUtils";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
// @ts-ignore
import { MailIcon } from "@vueEntry/SvgIcons/MailIcon";
// @ts-ignore
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
//@ts-ignore
import InsertionCard from "@vueEntry/InsertionCard.vue";
//@ts-ignore
import ShimmerLoader from "@vueEntry/ShimmerLoader.vue";
//@ts-ignore
import { redirectToApp } from "@utils/AppRedirectUtils";
var insertionHandlerClick = null;
var insertionMediaWrapperClick = null;
var realEstateListingApp = createApp({
  name: "RealEstate",
  components: Object.assign(Object.assign(Object.assign(Object.assign({
    //@ts-ignore
    "filters-modal": defineAsyncComponent(() => import("@vmodals/FiltersModal.vue")),
    //@ts-ignore
    "orders-modal": defineAsyncComponent(() => import("@vueEntry/Modals/OrderModal.vue")),
    //@ts-ignore
    cchart: defineAsyncComponent(() => import("@vueEntry/cchart.vue")),
    AccessibleSelect,
    ValuationBanner,
    PublicUserMenu,
    PlaceBox,
    BaseButton,
    BaseIcon,
    BaseComplexToggle,
    BaseTooltip,
    BaseBtModal,
    BaseDropDown,
    BlogBanner,
    InsertionCard,
    ShimmerLoader,
    //@ts-ignore
    "base-sidebar": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseSidebar.vue")),
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(() => import("@vueEntry/SwiperCarousel.vue")),
    IntersectionObservableVue,
    IntersectionObserverVue,
    BaseBadge,
    //@ts-ignore
    "map-modal": defineAsyncComponent(() => import("@vmodals/MapModal.vue")),
    //@ts-ignore
    "place-modal": defineAsyncComponent(() => import("@vmodals/PlaceModal.vue")),
    //@ts-ignore
    "save-search-modal": defineAsyncComponent(() => import("./vue/Modals/SaveSearchModal.vue")),
    //@ts-ignore
    "share-modal": defineAsyncComponent(() => import("./vue/Modals/ShareModal.vue")),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(() => import("./vue/Modals/ContactAgencyModal.vue")),
    //@ts-ignore
    "mail-alert-on-favourite-modal": defineAsyncComponent(() => import("./vue/Modals/MailAlertOnFavouriteModal.vue"))
  }, commonAsyncComponents), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons), {
    MailIcon,
    PhoneIcon
  }),
  setup() {
    var seoFilters = ref();
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps
    } = useBaseSnackbar();
    var {
      handleAddFavorite,
      handleRemoveFavorite
    } = useFavourite();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      amdLabels,
      amdIcons,
      listingType,
      openContactModal,
      openAndReturnToCAMS
    } = useContactAgencyModal();
    var {
      saveSearchModalIcons,
      saveSearchModalLabels,
      realEstateMiniItem,
      realEstateBean,
      ssmPlace
    } = useSaveSearchModal();
    var {
      search,
      setOrderAndSearch
    } = useSearch();
    var {
      shareModalData,
      openShareModal,
      gaEvent
    } = useShareModal();
    var {
      showPhone
    } = useShowPhone();
    var {
      redirectTo
    } = useUtilities();
    var {
      isLarge,
      isDesktopMode
    } = useBreakpoints();
    return {
      isLarge,
      isDesktopMode,
      showPhone,
      isAppBannerVisible,
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData,
      reopenAfterLogin,
      successModalDataEmitted,
      //CAM computed
      amdLabels,
      amdIcons,
      listingType,
      //CAM methods
      openContactModal,
      openAndReturnToCAMS,
      handleAddFavorite,
      handleRemoveFavorite,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      //useSaveSearch
      saveSearchModalIcons,
      saveSearchModalLabels,
      realEstateMiniItem,
      realEstateBean,
      ssmPlace,
      //useSearch
      search,
      setOrderAndSearch,
      //useShareModal
      shareModalData,
      openShareModal,
      gaEvent,
      redirectTo,
      seoFilters
    };
  },
  data() {
    return {
      wikiDescriptionShowMore: false,
      ListingInit: {
        list: "#list-properties",
        "getMapMarkers": getMapMarkers,
        "buildInfoWindow": buildInfoWindow,
        click: true
      },
      updateSSCSet: false,
      aroundMe: false,
      place: JSON.parse(_serializedPlace),
      isSale: isSale,
      isRent: isRent,
      graphDataResponse: [],
      graphData: [],
      smScreen: window.screen.width < BREAKPOINT.SMALL,
      activeListener: true,
      activeMode: "Lista",
      observerOptions: {
        rootMargin: "0px",
        threshold: 1.0
      },
      chartIsShowed: false,
      /* Shows the saveSearch popup */
      mapInitialized: false,
      agencyFilter: null,
      customListingTypologyURL: "",
      useContractType: true,
      casaClickHover: false,
      popoverVisible: false,
      map: null,
      isAuction: false,
      consultants: [],
      isBtnScrollLeftVisible: false,
      isBtnScrollRightVisible: true,
      previewCardRealEstateMap: [],
      isPreviewCardSidebarVisible: false,
      lastMarkersClicked: [],
      loadingPreviewCard: false,
      closeSidebar: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
    mapRangeForMarkers() {
      return window._freesearch || this.searchBean.placeType == PLACE_TYPE.REGION || this.searchBean.placeType == PLACE_TYPE.PROVINCE ? 1000000 : window._mapRange;
    },
    checkedMap() {
      return window.location.hash === "#map";
    },
    checkedList() {
      return !this.checkedMap || window.location.hash === "#list";
    },
    polygonPoints() {
      return this.searchBean.polygonFromMap ? parsePoints(this.searchBean.polygonFromMap) : [];
    },
    currentMapCenter() {
      var _a, _b;
      return this.searchBean.polygonFromMap ? calcPolygonCenter(this.polygonPoints) : {
        lat: ((_a = this.place) === null || _a === void 0 ? void 0 : _a.latitude) || 42.4153262,
        lng: ((_b = this.place) === null || _b === void 0 ? void 0 : _b.longitude) || 12.6428742
      };
    },
    listMode() {
      return this.activeMode === "Lista";
    },
    mapMode() {
      return !this.listMode;
    },
    orderOptions() {
      return window["orderOptions"];
    },
    orderSelected() {
      return this.orderOptions.find(option => option.id === this.searchBean.filterOrderId) || {
        id: 0
      };
    },
    realEstateSearchBean() {
      var _serializedSearchBean = window["_serializedSearchBean"];
      if (!_serializedSearchBean) return {};
      return JSON.parse(_serializedSearchBean);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(useSearchBeanStore, ["searchBean"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name", "favoriteIdList", "lastFavouriteModifiedId"])), mapState(useModalStore, ["showModal"])), mapState(useMetadataStore, ["pageName"])),
  watch: {
    activeMode(cur) {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      return __awaiter(this, void 0, void 0, function* () {
        if (cur === LISTING_MODE.MAP) {
          sendGAEvent("re_listing_view", {
            view_type: "map",
            event_location: this.pageName,
            real_estate_contract_type: window._listing_contract_type
          });
          (_a = this.$refs.mapButton) === null || _a === void 0 ? void 0 : _a.classList.add("tw-hidden");
          (_b = this.$refs.listButton) === null || _b === void 0 ? void 0 : _b.classList.remove("tw-hidden");
          (_c = this.$refs.footer) === null || _c === void 0 ? void 0 : _c.classList.add("tw-hidden");
          (_d = this.$refs.footer) === null || _d === void 0 ? void 0 : _d.classList.remove("tw-block");
          window.history.pushState(Date.now(), "", "#map");
          if (!this.mapInitialized) {
            yield this.initMap();
            this.mapInitialized = true;
          } else window.dispatchEvent(new Event("resize"));
        } else {
          sendGAEvent("re_listing_view", {
            view_type: "default",
            event_location: this.pageName,
            real_estate_contract_type: window._listing_contract_type
          });
          window.history.pushState(Date.now(), "", "#list");
          (_e = this.$refs.listButton) === null || _e === void 0 ? void 0 : _e.classList.add("tw-hidden");
          (_f = this.$refs.mapButton) === null || _f === void 0 ? void 0 : _f.classList.remove("tw-hidden");
          (_g = this.$refs.footer) === null || _g === void 0 ? void 0 : _g.classList.add("tw-block");
          (_h = this.$refs.footer) === null || _h === void 0 ? void 0 : _h.classList.remove("tw-hidden");
        }
      });
    },
    favoriteIdList: {
      handler(cur, prev) {
        if (this.map) {
          if (cur.length < prev.length) {
            this.map.updateIconFavourite(this.lastFavouriteModifiedId, false);
          } else {
            this.map.updateIconFavourite(this.lastFavouriteModifiedId, true);
          }
        }
      },
      deep: true
    }
  },
  created() {
    return __awaiter(this, void 0, void 0, function* () {
      this.checkedList && sendGAEvent("re_listing_view", {
        view_type: "default",
        event_location: this.pageName,
        real_estate_contract_type: window._listing_contract_type
      });
      this.updateRES();
      this.initPublicUserMenu();
      this.addShareOnMapEvent();
      /*this.showSaveSearchTooltip();*/ // temp disabilitato, cambio SEO, da tenere in in caso possa riservire a breve
      this.updateSearchBean(JSON.parse(window._serializedSearchBean));
      //default set to disclaimer
      this.openModal("DISCLAIMER_MODAL");
      this.isAuction = this.searchBean.contractType == 3;
    });
  },
  mounted() {
    hideZonesBreadcrumb();
    Listing.init({
      list: "#list-properties",
      getMapMarkers: getMapMarkers,
      buildInfoWindow: buildInfoWindow
    });
    if (!window["_bot"]) {
      updateViewListing(Listing.page.map(re => ({
        agencyId: re.agencyId,
        realEstateId: re.id
      })));
    }
    var chartContainer = document.getElementById("container-chart");
    if (!chartContainer) return;
    var observerTarget = chartContainer;
    if (chartContainer) {
      var callback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            import("chart.js").then(() => {
              this.chartIsShowed = true;
              this.getGraphData(isSale).then(() => {
                observer.unobserve(observerTarget);
              });
            });
          }
        });
      };
      var observer = new IntersectionObserver(callback, this.observerOptions);
      observer.observe(chartContainer);
    }
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    transformReImages,
    handleBreadcrumbLinkClick,
    handleInsertionClick,
    useApp() {
      redirectToApp("Listato - Banner");
    },
    openModal(modalName) {
      this.setShowModal(modalName);
    },
    closeModal() {
      this.setShowModal("NO_MODAL");
    },
    openMap(obj) {
      this.aroundMe = obj.aroundMe;
      this.setShowModal("MAP_MODAL");
    },
    updateRES() {
      if (!decodeCookie("newSearch")) return;
      updateRealEstateSearch(this.realEstateSearchBean).then(() => {
        removeCookie("newSearch");
      });
    },
    closeSaveSearchModal() {
      encodeCookie("saveSearchModal", {}, 1);
      this.setShowModal(Modals.noModal);
    },
    showSaveSearchTooltip() {
      var ssCookie = decodeCookie("saveSearchModal");
      if (ssCookie !== null && !window._freesearch) return;
      if (window.screen.width >= 992 && window["_showSaveSearchModal"] && !window._freesearch && !window.location.search.includes("privateArea=true") && !window.location.search.includes("c=0")) {
        this.setShowModal(Modals.saveSearchModal);
      } else if (window.screen.width < 576 && !window.location.search.includes("privateArea=true")) {
        this.popoverVisible = true;
        var rootEl = document.getElementById("real-estate-main");
        ["click", "scroll"].forEach(eventName => {
          rootEl === null || rootEl === void 0 ? void 0 : rootEl.addEventListener(eventName, () => {
            this.hidePopoverMailAlert();
          });
        });
      }
    },
    getGraphData(sale) {
      return __awaiter(this, void 0, void 0, function* () {
        var filters = {
          contract: "sale",
          macroTypologyId: 1
        };
        if (!sale) {
          filters.contract = "rent";
        }
        try {
          var response = yield axios.post("/rest/statistics/getAveragePriceGraphData/".concat(filters.contract, "/").concat(filters.macroTypologyId), this.place, {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            }
          });
          this.graphDataResponse = response.data;
          this.graphData = this.graphDataResponse.slice(Math.max(this.graphDataResponse.length - 12));
        } catch (err) {
          console.error(err);
        }
      });
    },
    addShareOnMapEvent() {
      document.addEventListener("share-event", e => {
        var payload = e.detail;
        this.openShareModal(payload, "".concat(this.pageName, " - Card Mappa"), "real_estate_share");
      });
    },
    initMap() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        var [leafletModule, leafletThemeModule, mapCssModule] = yield Promise.all([
        //@ts-ignore
        import( /* webpackChunkName: "chunks/leaflet_map" */"@wkWebSrc/js/LeafletMap/leaflet_map"), require( /* webpackChunkName: "chunks/leaflet_theme" */"../style/vendor/leafleft.theme.css"), require( /* webpackChunkName: "chunks/map" */"../style/layout/map.css")]);
        var leaflet = leafletModule.default;
        this.map = new leaflet();
        var map_selector = this.$refs.listingMapPlaceholder;
        try {
          yield (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(map_selector, MAP_TILER_APIKEY, COLORS, undefined, undefined, this.isDesktopMode ? 12 : 11);
          if (!this.isDesktopMode) {
            this.map.on("click", () => {
              var _a, _b;
              this.isPreviewCardSidebarVisible = false;
              this.loadingPreviewCard = false;
              (_a = document.getElementById("open-map-modal-btn-mobile")) === null || _a === void 0 ? void 0 : _a.classList.add("is-transitioned");
              (_b = document.getElementById("save-search-button-mobile-map")) === null || _b === void 0 ? void 0 : _b.classList.add("is-transitioned");
            });
          }
          this.map.startSpinner();
          (_b = this.ListingInit.getMapMarkers()) === null || _b === void 0 ? void 0 : _b.then(markers => {
            var _a, _b;
            if (this.polygonPoints.length) {
              (_a = this.map) === null || _a === void 0 ? void 0 : _a.deleteShape();
              (_b = this.map) === null || _b === void 0 ? void 0 : _b.drawPolygonFromPoints(this.polygonPoints);
            }
            if (markers.length > 0) {
              this.map.initMarkerClusterer();
              this.map.addMarkerBulk(markers, this.currentMapCenter, this.mapRangeForMarkers, this.favoriteIdList);
            }
            if (this.map.hasShape()) this.map.fitBounds(this.map.getShape().getBounds());else if (this.map.getMarkersCount()) this.map.fitBounds(this.map.getMarkerClusterer().getBounds());
            this.map.getMap().invalidateSize();
            this.map.on("click movestart", () => {
              if (this.isDesktopMode) this.closeSidebar = true;
            });
            //Single marker
            this.map.addListener(this.map.getMarkerClusterer(), "click", e => __awaiter(this, void 0, void 0, function* () {
              var _c, _d;
              var marker = e.propagatedFrom;
              if (!this.isDesktopMode) {
                (_c = document.getElementById("open-map-modal-btn-mobile")) === null || _c === void 0 ? void 0 : _c.classList.add("is-transitioned");
                (_d = document.getElementById("save-search-button-mobile-map")) === null || _d === void 0 ? void 0 : _d.classList.add("is-transitioned");
                //this is needed because the map is not centered correctly on mobile devices that have a height less than 770px
                if (innerHeight < 770) {
                  var space = 0.0005;
                  var lat = +(marker.getLatLng().lat - space).toFixed(6);
                  this.map.setCenter(lat, marker.getLatLng().lng, 18);
                } else this.map.setCenter(marker.getLatLng().lat, marker.getLatLng().lng, this.map.getZoom());
              }
              this.isPreviewCardSidebarVisible = true;
              if (this.lastMarkersClicked.find(id => marker["id"].includes(id))) {
                this.loadingPreviewCard = true;
                return;
              }
              this.loadingPreviewCard = false;
              try {
                this.lastMarkersClicked = [];
                this.lastMarkersClicked.push(...marker["id"]);
                this.previewCardRealEstateMap = yield buildInfoWindow(marker["id"]);
                this.loadingPreviewCard = true;
              } catch (e) {
                console.error(e);
              }
            }));
          }).finally(() => {
            this.map.stopSpinner();
          });
        } catch (e) {
          console.error(e);
        }
      });
    },
    setActiveMode(newMode) {
      this.activeMode = newMode;
    },
    hidePopoverMailAlert() {
      if (!this.popoverVisible) return;
      this.popoverVisible = false;
      encodeCookie("saveSearchModal", {}, 1);
    },
    scrollLeft() {
      var {
        seoFilters
      } = this;
      var {
        scrollLeft,
        scrollWidth,
        offsetWidth
      } = seoFilters;
      var newScrollLeft = scrollLeft - 180;
      seoFilters.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
      this.handleArrowVisibilityOfSeoFilters(newScrollLeft, scrollWidth, offsetWidth);
    },
    scrollRight() {
      var {
        seoFilters
      } = this;
      var {
        scrollLeft,
        scrollWidth,
        offsetWidth
      } = seoFilters;
      var newScrollLeft = scrollLeft + 180;
      seoFilters.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
      this.handleArrowVisibilityOfSeoFilters(newScrollLeft, scrollWidth, offsetWidth);
    },
    handleScrolling() {
      this.handleArrowVisibilityOfSeoFilters(this.seoFilters.scrollLeft, this.seoFilters.scrollWidth, this.seoFilters.offsetWidth);
    },
    handleArrowVisibilityOfSeoFilters(scrollLeft, scrollWidth, offsetWidth) {
      this.isBtnScrollLeftVisible = scrollLeft > 0;
      this.isBtnScrollRightVisible = scrollWidth - Math.round(scrollLeft) > offsetWidth;
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useSearchBeanStore, ["updateSearchBean"])), mapActions(useModalStore, ["setShowModal"])), mapActions(usePublicUserMenuStore, ["increaseSavedSearches", "getFavoriteById"]))
});
realEstateListingApp.use(createPinia());
realEstateListingApp.mount("#real-estate-main");
// Stefano S. this var is need for creating url correctly within infoWindows on map view listings
var urlLang = window["_lang"] == "it" ? "" : "/" + window["_lang"];
var dispatchInitFavoritesEvent = realEstateIdList => {
  var initFavoriteEvent = new CustomEvent("init-favorite-event", {
    detail: {
      realEstateIdList
    }
  });
  document.dispatchEvent(initFavoriteEvent);
};
var dispatchChangeFavoriteEvent = (realEstateId, action) => {
  var changeFavoriteEvent = new CustomEvent("change-favorite-event", {
    detail: {
      realEstateId,
      action
    }
  });
  document.dispatchEvent(changeFavoriteEvent);
};
var dispatchShareEvent = (title, url) => {
  document.dispatchEvent(new CustomEvent("share-event", {
    detail: {
      title,
      url
    }
  }));
};
var isMapFavorite = function isMapFavorite(elem) {
  var dispatchEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (elem.classList.contains("fav-save")) {
    var realEstateId = Number(elem.getAttribute("data-id"));
    dispatchEvent && dispatchChangeFavoriteEvent(realEstateId, "save");
    return true;
  } else if (elem.classList.contains("fav-remove")) {
    var _realEstateId = Number(elem.getAttribute("data-id"));
    dispatchEvent && dispatchChangeFavoriteEvent(_realEstateId, "delete");
  }
  return false;
};
var isShareBtn = function isShareBtn(elem) {
  var dispatchEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!elem.classList.contains("share")) return false;
  dispatchEvent && dispatchShareEvent(elem.getAttribute("data-title"), elem.getAttribute("data-url"));
  return true;
};
var handleMapInsertionClick = () => {
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  var _loop = function _loop() {
    insertionMediaWrapperClick = e => e.preventDefault();
    //Avoid catching from children elements
    mediaWrapperEl.addEventListener("click", insertionMediaWrapperClick);
    var insertionMapEl = mediaWrapperEl.parentElement;
    if (!insertionMapEl) return 1; // continue
    var {
      url
    } = insertionMapEl.dataset;
    insertionHandlerClick = _ref => {
      var {
        target
      } = _ref;
      var curTarget = target;
      var curTargetParent = curTarget.parentElement;
      //If we click the save btn or the share btn we won't redirect the user
      if (isMapFavorite(curTarget, false) || curTargetParent && isMapFavorite(curTargetParent, false) || isShareBtn(curTarget) || curTargetParent && isShareBtn(curTargetParent, false)) return;
      handleInsertionClick({
        url: url || "",
        blankPage: {
          lg: true
        }
      });
    };
    //Adding insertion on click handler
    insertionMapEl.addEventListener("click", insertionHandlerClick);
  };
  for (var mediaWrapperEl of mediaWrapperList) {
    if (_loop()) continue;
  }
};
var removeMapInsertionClickListener = () => {
  var _a;
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  for (var mediaWrapperEl of mediaWrapperList) {
    insertionMediaWrapperClick && mediaWrapperEl.removeEventListener("click", insertionMediaWrapperClick);
    insertionHandlerClick && ((_a = mediaWrapperEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", insertionHandlerClick));
  }
  insertionHandlerClick = null;
  insertionMediaWrapperClick = null;
};
document.addEventListener("info-event-created", e => {
  var elems = document.querySelectorAll("#infowindow > .wrapper-multiple > li");
  handleMapInsertionClick();
  var realEstateIdList = [];
  elems.forEach(e => {
    var realEstateId = Number(e.getAttribute("data-id"));
    realEstateIdList.push(realEstateId);
  });
  dispatchInitFavoritesEvent(realEstateIdList);
  var carouselElems = document.getElementsByClassName("infowindow-carousel-container")[0];
  var infoWindowElem = document.getElementById("infowindow");
  var handleMapFavorite = e => {
    if (!e.target) return;
    var target = e.target;
    if (isMapFavorite(target)) return;
    if (isShareBtn(target)) return;
    var {
      parentElement
    } = target;
    isMapFavorite(parentElement);
    isShareBtn(parentElement);
  };
  infoWindowElem === null || infoWindowElem === void 0 ? void 0 : infoWindowElem.addEventListener("click", handleMapFavorite);
  carouselElems === null || carouselElems === void 0 ? void 0 : carouselElems.addEventListener("click", handleMapFavorite);
});
function hideZonesBreadcrumb() {
  var zonesBreadcrumb = document.getElementById("navigation-dropdown-breadcrump");
  document.addEventListener("scroll", () => {
    zonesBreadcrumb === null || zonesBreadcrumb === void 0 ? void 0 : zonesBreadcrumb.classList.remove("show");
  }, {
    passive: true
  });
}
function buildInfoWindow(ids) {
  return __awaiter(this, void 0, void 0, function* () {
    try {
      var data = yield getRealEstatesData(ids);
      if (!data) return [];
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  });
}